var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStayNotified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "033---Website-Notification",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 4v6h-29c-1.1032019-.0032948-1.9967052-.89679813-2-2v-2c-.0032948-1.10320187-.8967981-1.9967052-2-2h-25c0-2.209139 1.790861-4 4-4h50c2.209139 0 4 1.790861 4 4z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 10v4h-58v-10h25c1.1032019.0032948 1.9967052.89679813 2 2v2c.0032948 1.10320187.8967981 1.9967052 2 2z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 14v32c0 2.209139-1.790861 4-4 4h-50c-2.209139 0-4-1.790861-4-4v-32z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16 10h-11c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h11c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23.414 9 .293-.293c.3789722-.39237889.3735524-1.01608478-.0121814-1.40181858-.3857338-.38573379-1.0094397-.39115363-1.4018186-.01218142l-.293.293-.293-.293c-.3923789-.37897221-1.0160848-.37355237-1.4018186.01218142-.3857338.3857338-.3911536 1.00943969-.0121814 1.40181858l.293.293-.293.293c-.2599566.25107447-.3642126.62287789-.2726972.9725073.0915155.3496295.3645604.6226744.7141899.7141899.3496294.0915154.7214328-.0127406.9725073-.2726972l.293-.293.293.293c.3923789.3789722 1.0160848.3735524 1.4018186-.0121814s.3911536-1.00943971.0121814-1.4018186z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 52,
    cy: 5,
    fill: "#e64c3c",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 48,
    cy: 5,
    fill: "#f0c419",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 5,
    fill: "#4fba6f",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 22.17v-2.17c.0032948-1.1032019.8967981-1.9967052 2-2 1.095198.0223037 1.9776963.904802 2 2v2.17z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 52c0 3.3137085-2.6862915 6-6 6s-6-2.6862915-6-6z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e64c3c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m12.991 38c-.2626008.0002013-.5144784-.104148-.7-.29-.8878614-1.0266906-1.3497097-2.353923-1.291-3.71-.0576599-1.3551902.4045029-2.6812252 1.292-3.707.2525868-.2529441.6209306-.3519206.96628-.259646.3453493.0922745.6152374.3617814.708.707s-.0056932.713702-.25828.966646c-.5012824.6557616-.7523137 1.468777-.708 2.293-.0431581.8278281.21155 1.6437452.718 2.3.2835469.2892079.3646455.7208896.2053917 1.0932849s-.5274071.6119557-.9323917.6067151z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10 42c-.22153824.0000114-.4366785-.0742842-.611-.211-2.22051908-1.97134-3.46020371-4.8205296-3.389-7.789-.07196003-2.967991 1.16659307-5.8171021 3.386-7.789.43633448-.3244141 1.0519211-.2407504 1.3858464.188349.3339252.4290993.2638106 1.046376-.1578464 1.389651-1.73204135 1.5924269-2.68608249 3.8592783-2.614 6.211-.0719424 2.3533845.88367539 4.6216079 2.618 6.214.3349641.2634652.4661533.7102674.3267973 1.1130015-.1393559.4027342-.5186343.672902-.9447973.6729985z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45 38c-.4031626.0011535-.7675864-.2399059-.9242617-.6113817-.1566754-.3714757-.0749549-.8007031.2072617-1.0886183.5058542-.6565163.7601752-1.4723297.717-2.3.0437839-.8279068-.2109905-1.6440365-.718-2.3-.3744203-.3994507-.3610948-1.02486.03-1.408.3891622-.382722 1.0141325-.3800435 1.4.006.8852914 1.0248428 1.3459829 2.3489731 1.288 3.702.0581701 1.3552654-.4040564 2.6814835-1.292 3.707-.1877377.1877946-.4424587.2932088-.708.293z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 42c-.4263467.0003299-.8060166-.2696876-.9456341-.6725258-.1396175-.4028381-.0084746-.8498955.3266341-1.1134742 1.734694-1.5922101 2.6906874-3.8604585 2.619-6.214.0719424-2.3533845-.8836754-4.6216079-2.618-6.214-.4349242-.3404836-.5114835-.9690757-.171-1.404.3404836-.4349242.9690758-.5114835 1.404-.171 2.2189231 1.9721659 3.4570751 4.8211956 3.385 7.789.0720751 2.9678044-1.1660769 5.8168341-3.385 7.789-.1757736.1368747-.3922198.2111351-.615.211z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m41 34c-.0788035-6.5944997-5.4055003-11.9211965-12-12-6.627417 0-12 5.372583-12 12v4c0 6.351-2.49 8.718-3.956 9.562-.638021.3549585-1.0365646 1.0249239-1.044 1.755v.683c0 1.1045695.8954305 2 2 2h30c1.1045695 0 2-.8954305 2-2v-.683c-.0074354-.7300761-.405979-1.4000415-1.044-1.755-1.466-.844-3.956-3.211-3.956-9.562z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21 35c-.5522847 0-1-.4477153-1-1 .006061-4.9680501 4.0319499-8.993939 9-9 .5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-3.8641657.0044086-6.9955914 3.1358343-7 7 0 .5522847-.4477153 1-1 1z",
    fill: "#f3d55b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayNotified);
export default __webpack_public_path__ + "static/media/stay-notified.10c3a24fc86c0e1284d75018a8b915ca.svg";
export { ForwardRef as ReactComponent };